module.exports = __webpack_public_path__ + "img/PP_Sword_0080.74af4b38.png";